import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';

import { Default } from '../../../../layouts';

import useDatasource from '../../../../hooks/useDatasource';
import {
  deleteTVARate,
  getTVARates,
} from '../../../../services/taxonomies/tva-rate';

import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import Column from '../../../../helpers/columns';
import usePermissions from '../../../../hooks/usePermission';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';

const permissionsMap = {
  canView: ['ADMINISTRATION_TAXONOMIES_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const TVARatesList = () => {
  const { t } = useTranslation();
  const { pagination, content, handleChange, reload } =
    useDatasource(getTVARates);
  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);
  const columns = useMemo(
    () => [
      Column.text('id', t('entity.taxonomy.tvaRate.id'), {
        filter: true,
      }),
      Column.text('tvaRate', t('entity.taxonomy.tvaRate._singular'), {
        filter: true,
      }),
      Column.text('description', t('entity.taxonomy.tvaRate.description'), {
        filter: true,
      }),
      Column.date('dateStart', t('entity.taxonomy.tvaRate.dateStart'), {
        filter: true,
      }),
      Column.date('dateEnd', t('entity.taxonomy.tvaRate.dateEnd'), {
        filter: true,
      }),
      Column.bool('deleted', t('entity.taxonomy.tvaRate.status._'), {
        width: 150,
        filter: true,
        inverted: true,
        labels: [
          t('table.filter.all'),
          t('entity.taxonomy.tvaRate.status.true'),
          t('entity.taxonomy.tvaRate.status.false'),
          t('table.filter.unknown'),
        ],
      }),
      Column.actions(t('table.actions'), (record) => (
        <>
          {canView && (
            <ViewItemIcon path={`/admin/taxonomies/tva-rates/${record.id}`} />
          )}
          {canEdit && (
            <EditItemIcon path={`/admin/taxonomies/tva-rates/${record.id}`} />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t('entity.taxonomy.tvaRate._delete', record)}
              message={t('entity.taxonomy.tvaRate._deleted', record)}
              item={record}
              action={deleteTVARate}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [t, canView, canEdit, canDelete, reload],
  );
  return (
    <Default>
      <PageTitle title={t('entity.taxonomy.tvaRate._plural')}>
        {canEdit && (
          <AddEntityButton
            entity={t('entity.taxonomy.tvaRate._singular')}
            path="/admin/taxonomies/tva-rates/new"
          />
        )}
      </PageTitle>
      <Table
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
      />
    </Default>
  );
};

export default TVARatesList;
